module.exports = __webpack_public_path__ + "2ac01d14dfbc53d22288bccb45c546ee.png";